import { Component, OnInit, OnDestroy } from '@angular/core';
import { Auth } from 'src/app/models/auth';
import { DepartamentoCadastro } from 'src/app/models/departamento-cadastro';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Departamento } from 'src/app/models/departamento';
import { Subscription } from 'rxjs';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { Router, ActivatedRoute } from '@angular/router';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { StatusCadastro } from 'src/app/shared/enums/status-cadastro.enum';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-departamento-edit',
    templateUrl: './departamento-edit.component.html',
    styleUrls: ['./departamento-edit.component.css']
})
export class DepartamentoEditComponent implements OnInit, OnDestroy {

    private currentUser: Auth;
    public departamentoCadastro: DepartamentoCadastro;

    public departamentoFormGroup: FormGroup;
    public canEdit = false;

    private departamento: Departamento;
    private id: number;
    private routeSubscription: Subscription;
    public StatusCadastro = StatusCadastro;

    ngOnInit() {
        this.routeSubscription = this.route.paramMap.subscribe(params => {
            this.id = +params.get('id');
        });

        this.currentUser = this.authenticationService.currentUserValue;

        // usar para criar / editar
        this.createForm(new DepartamentoCadastro('', ''));
        // validar se foi para esse componente com o id do centro de custo (sim = editar) (não = cadastrar)
        this.departamentoService.getById(this.id, this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.departamento = response.result;
                this.createForm(this.departamento);
                this.canEdit = true;
            },
            error => {
                this.alertService.error('Não foi possível encontrar o centro de custo.');
                this.router.navigate(['list'], { relativeTo: this.route.parent });
            }
        );

    }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }

    constructor(
        private formBuilder: FormBuilder,
        private departamentoService: DepartamentoService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router,
        private route: ActivatedRoute) {
    }

    public get form() {
        return this.departamentoFormGroup.controls;
    }

    createForm(departamentoCadastro: DepartamentoCadastro) {
        this.departamentoFormGroup = this.formBuilder.group({
            nome: new FormControl(departamentoCadastro.nome, [
                Validators.required,
                Validators.maxLength(100)
            ]),
            codigo: new FormControl(departamentoCadastro.codigo, [
                Validators.required,
                Validators.maxLength(15)
            ]),
            status: new FormControl(departamentoCadastro.status, [

            ])
        });
    }

    onSubmit(departamentoCadastro: DepartamentoCadastro) {
        if (this.departamentoFormGroup.valid) {
            this.departamentoService
                .update(this.id, departamentoCadastro, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.alertService.success(response.message, true);
                            this.router.navigate(['list'], { relativeTo: this.route.parent });
                        } else {
                            this.alertService.error(response.message);
                        }
                    }
                );
        } else {
            GenericValidator.verifierValidatorsForm(this.departamentoFormGroup);
        }
    }

}
